<div>{{CellData['label']}}</div>